import React, { useEffect, useState } from "react";
import Close from "./icons/Close";
import s from "./style.module.scss";
import Button from "shared/ui/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { VisitBonusApi } from "./api";
import { useAppDispatch, useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import { showError } from "shared/lib/showError";
import { showSuccess } from "shared/lib/showSuccess";
import { ROUTES_PATH } from "shared/constants/routesPath";
import { Html5Qrcode } from "html5-qrcode";

interface QRData {
  token: string;
  expire: number;
}

const ScanContent: React.FC = () => {
  const { pathname } = useLocation();
  const { auth_key, user_info } = useAppSelector(userSelect);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [scanResult, setScanResult] = useState<string | null>(null);
  const [dataSending, setDataSending] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const qrCodeScannerId = "qr-scanner"; // Идентификатор контейнера

  useEffect(() => {
    const html5QrCode = new Html5Qrcode(qrCodeScannerId);

    const startScanner = async () => {
      try {
        await html5QrCode.start(
          { facingMode: "environment" },
          { fps: 1, qrbox: { width: 240, height: 240 } },
          async (decodedText) => {
            setScanResult(decodedText);
          },
          (errorMessage) => {
            console.warn("QR Scanner error:", errorMessage);
            // Логируем, но не прерываем процесс
          }
        );
      } catch (err) {
        console.error("Ошибка запуска сканера:", err);
      }
    };

    // Инициализация
    startScanner();

    // Очистка при размонтировании
    return () => {
      html5QrCode.stop().catch(() => null); // Игнорируем ошибки остановки
      // html5QrCode.clear();
    };
  }, []);

  useEffect(() => {}, [pathname]);

  useEffect(() => {
    if (scanResult && !dataSending && auth_key && user_info && !isSuccess) {
      setDataSending(true);

      VisitBonusApi({
        token: scanResult,
        auth_key,
        user_id: user_info.id,
      })
        .then(() => {
          setIsSuccess(true);
          showSuccess(
            dispatch,
            "Успешное сканирование",
            "QR код получен, спасибо! Баллы начислены."
          );
          navigate(ROUTES_PATH.HOME);
        })
        .catch((e) => showError(e, dispatch))
        .finally(() => {
          setDataSending(false);
          setScanResult(null);
        });
    }
  }, [scanResult, dataSending, auth_key, user_info, isSuccess]);

  return (
    <div className={s.scan}>
      <Link to={ROUTES_PATH.HOME} className={s.close}>
        <Close />
      </Link>

      <h1>Отсканируйте QR-код</h1>

      <div className={s.info}>
        <p>
          Для того чтобы получить баллы, наведите камеру на QR-код чека или
          QR-код на стойке
        </p>

        <div className={s.image}>
          <img src="/image/qr/01.png" alt="QR code" />
        </div>
      </div>

      <div id={qrCodeScannerId} className={s.scanner}>
        {/* <QrReader
          onResult={(result, error) => {
            if (result) handleScan(result?.getText());
            if (error) handleError(error);
          }}
          constraints={{ facingMode: "environment" }}
          scanDelay={300}
        /> */}
        {/* {error && <p style={{ color: "red" }}>Ошибка: {error}</p>} */}
      </div>

      <div className={s.buttons}>
        <Button href={ROUTES_PATH.HOME}>Вернуться на главную</Button>
      </div>
    </div>
  );
};

export default ScanContent;
